import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { PlanningMonths } from "src/app/types/planning";
import { useIntl } from "react-intl";

const usePlanningMonthsOptions = () => {
    const [planningMonthsOptions, setPlanningMonthsOptions] = useState<
        Array<SimpleFormSelectOption>
    >([]);
    const { formatMessage } = useIntl();
    const [loading] = useState(false);
    const [error] = useState();

    useEffect(() => {
        setPlanningMonthsOptions(
            PlanningMonths.map((value) => ({
                label: `${value} ${formatMessage({ id: "common.field.months" })}`,
                value,
            }))
        );
    }, []);

    return { planningMonthsOptions, loading, error };
};

export default usePlanningMonthsOptions;
